import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53a1a91d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 1,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1","cursor":"unset"} }, null, -1))
const _hoisted_4 = { class: "discord" }
const _hoisted_5 = { class: "discord-links" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/WzejVAx",
    target: "_blank"
  }, "The Paper Pilot Community")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/F3xveHV",
    target: "_blank"
  }, "The Modding Tree")
], -1))
const _hoisted_10 = {
  href: "https://forums.moddingtree.com/",
  target: "_blank"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "forum", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "info", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "library_books", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "settings", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "library_books", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "settings", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "info", -1))
const _hoisted_18 = {
  href: "https://forums.moddingtree.com/",
  target: "_blank"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "forum", -1))
const _hoisted_20 = { class: "discord" }
const _hoisted_21 = { class: "discord-links" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/WzejVAx",
    target: "_blank"
  }, "The Paper Pilot Community")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/F3xveHV",
    target: "_blank"
  }, "The Modding Tree")
], -1))

import Changelog from "data/Changelog.vue";
import projInfo from "data/projInfo.json";
import { ComponentPublicInstance, ref } from "vue";
import Info from "./Info.vue";
import Options from "./Options.vue";
import SavesManager from "./SavesManager.vue";
import Tooltip from "features/tooltips/Tooltip.vue";
import { Direction } from "util/common";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const info = ref<ComponentPublicInstance<typeof Info> | null>(null);
const savesManager = ref<ComponentPublicInstance<typeof SavesManager> | null>(null);
const options = ref<ComponentPublicInstance<typeof Options> | null>(null);
// For some reason Info won't accept the changelog unless I do this:
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const changelog = ref<ComponentPublicInstance<any> | null>(null);

const { useHeader, banner, title, discordName, discordLink, versionNumber } = projInfo;

function openDiscord() {
    window.open(discordLink, "mywindow");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(useHeader))
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 0,
          class: "nav"
        }, _ctx.$attrs), [
          (_unref(banner))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(banner),
                class: "banner",
                alt: _unref(title)
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(title)), 1)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changelog.value?.open())),
            class: "version-container"
          }, [
            _createVNode(Tooltip, {
              display: "Changelog",
              direction: _unref(Direction).Down,
              class: "version"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "v" + _toDisplayString(_unref(versionNumber)), 1)
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              onClick: openDiscord,
              class: "material-icons"
            }, "discord"),
            _createElementVNode("ul", _hoisted_5, [
              (_unref(discordLink) !== 'https://discord.gg/WzejVAx')
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createElementVNode("a", {
                      href: _unref(discordLink),
                      target: "_blank"
                    }, _toDisplayString(_unref(discordName)), 9, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", _hoisted_10, [
              _createVNode(Tooltip, {
                display: "Forums",
                direction: _unref(Direction).Down,
                yoffset: "5px"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["direction"])
            ])
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (info.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Info",
              direction: _unref(Direction).Down,
              class: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (savesManager.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Saves",
              direction: _unref(Direction).Down,
              xoffset: "-20px"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (options.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Options",
              direction: _unref(Direction).Down,
              xoffset: "-66px"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["direction"])
          ])
        ], 16))
      : (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 1,
          class: "overlay-nav"
        }, _ctx.$attrs), [
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (changelog.value?.open())),
            class: "version-container"
          }, [
            _createVNode(Tooltip, {
              display: "Changelog",
              direction: _unref(Direction).Right,
              xoffset: "25%",
              class: "version"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "v" + _toDisplayString(_unref(versionNumber)), 1)
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (savesManager.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Saves",
              direction: _unref(Direction).Right
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (options.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Options",
              direction: _unref(Direction).Right
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (info.value?.open()))
          }, [
            _createVNode(Tooltip, {
              display: "Info",
              direction: _unref(Direction).Right
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["direction"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", _hoisted_18, [
              _createVNode(Tooltip, {
                display: "Forums",
                direction: _unref(Direction).Right,
                xoffset: "7px"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["direction"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", {
              onClick: openDiscord,
              class: "material-icons"
            }, "discord"),
            _createElementVNode("ul", _hoisted_21, [
              (_unref(discordLink) !== 'https://discord.gg/WzejVAx')
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                    _createElementVNode("a", {
                      href: _unref(discordLink),
                      target: "_blank"
                    }, _toDisplayString(_unref(discordName)), 9, _hoisted_23)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_24,
              _hoisted_25
            ])
          ])
        ], 16)),
    _createVNode(Info, {
      ref_key: "info",
      ref: info,
      changelog: changelog.value
    }, null, 8, ["changelog"]),
    _createVNode(SavesManager, {
      ref_key: "savesManager",
      ref: savesManager
    }, null, 512),
    _createVNode(Options, {
      ref_key: "options",
      ref: options
    }, null, 512),
    _createVNode(Changelog, {
      ref_key: "changelog",
      ref: changelog
    }, null, 512)
  ], 64))
}
}

})